import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    TextField,
    MenuItem,
    Grid,
    Typography,
    Container,
    Paper,
    Divider,
    Button, IconButton
} from '@mui/material';
import AppBarComponent from '../../../component/appbar';
import { GetUserById, UpdateUserData, UserRegister } from '../../../service/user_service';
import { AlertError, AlertLoading, AlertSuccess } from '../../../component/popupAlert';
import Cookies from 'js-cookie';
// import './style.css';

const Resgiter_view = () => {

    const navigate = useNavigate();
    const token = Cookies.get('token');
    const { id } = useParams();
    const location = useLocation();
    const pathname = location.pathname;

    const [viewState, setViewState] = useState(false)
    const [editMode, setEditMode] = useState(false)

    const initialUserData = {
        user_id: '',
        username: '',
        password: '',
        email: '',
        tel: '',
        role: '',
        first_name: '',
        last_name: '',
        gender: '',
        birthDate: '',
        birthMonth: '',
        birthYear: '',
        date_of_birth: '',
    };

    const [userData, setUserData] = useState(initialUserData);
    const [errorsVaridate, setErrorsVaridate] = useState({
        user_id: false,
        username: false,
        password: false,
        email: false,
        tel: false,
        first_name: false,
        last_name: false,
        gender: false,
        role: false
    });

    useEffect(() => {
        if (!token) {
            navigate('/login');
            return;
        }

        if (pathname.includes('/view')) {
            handleGetUserData()
            setEditMode(true)
            setViewState(true)
        } else {
            setUserData(initialUserData);
        }

        // handleGetEmtpyBoat()
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserData(prevData => {
            const updatedData = { ...prevData, [name]: value };
            if (name === "user_id") {
                updatedData.username = value;
            }

            // Combine birth date fields if all are present
            if (['birthDate', 'birthMonth', 'birthYear'].includes(name)) {
                const { birthDate, birthMonth, birthYear } = updatedData;
                if (birthDate && birthMonth && birthYear) {
                    updatedData.date_of_birth = `${birthDate}-${birthMonth}-${birthYear}`;
                }
            }
            return updatedData;
        });
    };

    const handleGetUserData = async () => {
        try {
            const res = await GetUserById(id)
            setUserData(res);
        } catch (error) {
            console.error('handleGetUserData', error.message)
            setUserData(initialUserData)
            navigate('/404')
        }
    };

    const handleValidate = () => {
        // const requiredFields = [
        //     'user_id', 'username', 'password', 'first_name', 'last_name', 'email', 'gender', 'role'
        // ];

        console.log(userData)
        let requiredFields;
        if(viewState){
            requiredFields = ['user_id', 'username', 'first_name', 'last_name', 'email', 'gender', 'role']
        }else{
            requiredFields = ['user_id', 'username', 'password', 'first_name', 'last_name', 'email', 'gender', 'role']
        }

        const emptyFields = requiredFields.filter(field => {
            const value = userData[field];
            return value === undefined || value === null || value === '' ||
                (typeof value === 'number' && isNaN(value));
        });

        setErrorsVaridate(prevValid => {
            const newValid = { ...prevValid };
            requiredFields.forEach(field => {
                newValid[field] = emptyFields.includes(field);
            });
            return newValid;
        });

        return { isValid: emptyFields.length === 0, emptyFields };
    };

    const handleSubmit = async () => {
        const { isValid, emptyFields } = handleValidate();

        if (isValid) {
            AlertLoading();
            try {
                if (!viewState) {
                    console.log(userData)
                    const res = await UserRegister(userData, token)
                    handleReset();
                    AlertSuccess('สร้างบัญชีสำเร็จ');
                    navigate('/thewonderblueadmin_employee')
                } else {
                    const data = userData
                    data.id = id;
                    // console.log(data);
                    const res = await UpdateUserData(data)
                    navigate('/thewonderblueadmin_employee')
                    AlertSuccess('แก้ไขข้อมูลสำเร็จ');
                }
            } catch (e) {
                AlertError('เกิดข้อผิดพลาด', e.message);
            }
        } else {
            console.log(emptyFields);
            AlertError('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง');
        }
    };

    const handleReset = () => {
        // เปลี่ยนจาก setUserData({}) เป็น
        setUserData(initialUserData);
    };

    return (
        <Box sx={{ background: 'linear-gradient(180deg, rgba(212,212,212,1) 0%, rgba(239,239,239,1) 64%)' }}>
            <AppBarComponent />
            <Box>
                <Container maxWidth="lg" margin={4} sx={{ paddingBottom: '30px' }}>
                    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                                Create user account
                            </Typography>
                            {
                                viewState && (
                                    <Button variant="contained" color="primary" onClick={() => setEditMode(!editMode)}>
                                        แก้ไข
                                    </Button>
                                )
                            }
                        </Box>

                        <Box component="form" noValidate sx={{ mt: 3 }}>
                            <Box paddingBottom={4}>

                                <Typography variant="h6" component="h1" gutterBottom fontWeight={'bold'} marginTop={4}>
                                    1. ระบุข้อมูลพนักงาน
                                </Typography>

                                <Divider />

                                <Grid container spacing={2} marginTop={1}>
                                    <Grid item xs={12} sm={12}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            รหัสพนักงาน
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="รหัสพนักงาน"
                                            name="user_id"
                                            value={userData?.username || ''}
                                            error={errorsVaridate.username}
                                            disabled={editMode}
                                            onChange={handleChange}
                                            required
                                            margin="small"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            คำนำหน้าชื่อ
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="คำนำหน้า"
                                            name="prefix"
                                            value={userData?.prefix || ''}
                                            onChange={handleChange}
                                            disabled={editMode}
                                            required
                                            margin="small"
                                        >
                                            <MenuItem value="นาย">นาย</MenuItem>
                                            <MenuItem value="นาง">นาง</MenuItem>
                                            <MenuItem value="นางสาว">นางสาว</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            ชื่อจริง
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="ชื่อจริง"
                                            name="first_name"
                                            value={userData?.first_name || ''}
                                            error={errorsVaridate.first_name}
                                            disabled={editMode}
                                            onChange={handleChange}
                                            required
                                            margin="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            นามสกุล
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="นามสกุล"
                                            name="last_name"
                                            value={userData?.last_name || ''}
                                            error={errorsVaridate.last_name}
                                            disabled={editMode}
                                            onChange={handleChange}
                                            required
                                            margin="small"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={7}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            เพศ
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="เพศ"
                                            name="gender"
                                            value={userData?.gender || ''}
                                            disabled={editMode}
                                            onChange={handleChange}
                                            required
                                            margin="small"
                                        >
                                            <MenuItem value="ชาย">ชาย</MenuItem>
                                            <MenuItem value="หญิง">หญิง</MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} marginTop={1}>
                                    {/* <Grid item xs={12} sm={4}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            วันเกิด
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="วัน"
                                            name="birthDate"
                                            value={userData.birthDate}
                                            onChange={handleChange}
                                            margin="small"

                                        >
                                            {[...Array(31)].map((_, i) => (
                                                <MenuItem key={i} value={(i + 1).toString().padStart(2, '0')}>{i + 1}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            เดือนเกิด
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="เดือน"
                                            name="birthMonth"
                                            value={userData.birthMonth}
                                            onChange={handleChange}
                                            margin="small"
                                        >
                                            {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month, index) => (
                                                <MenuItem key={index} value={month}>{['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                                                    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'][index]}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            ปีเกิด
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="ปี"
                                            name="birthYear"
                                            value={userData.birthYear}
                                            onChange={handleChange}
                                            margin="small"
                                        >
                                            {[...Array(100)].map((_, i) => (
                                                <MenuItem key={i} value={(2024 - i).toString()}>{2024 - i}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid> */}

                                    {/* <Grid item xs={12} sm={4}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            อัพโหลดรูปโปรไฟล์
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton onClick={() => fileInputRef.current.click()}>
                                                        <CloudUpload />
                                                    </IconButton>
                                                ),
                                                readOnly: true,
                                            }}
                                            value={userData.profile_image_name || ''}
                                            placeholder="เลือกไฟล์รูปภาพ"
                                        />
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleImageUpload}
                                            style={{ display: 'none' }}
                                            accept="image/*"
                                        />
                                    </Grid> */}
                                </Grid>

                                <Typography variant="h6" component="h1" gutterBottom fontWeight={'bold'} marginTop={4}>
                                    2. ระบุข้อมูลสำหรับติดต่อ
                                </Typography>

                                <Divider />

                                <Grid container spacing={2} marginTop={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            อีเมล
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="email"
                                            name="email"
                                            value={userData?.email || ''}
                                            error={errorsVaridate.email}
                                            onChange={handleChange}
                                            disabled={editMode}
                                            required
                                            margin="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            เบอร์โทรศัพท์
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="เบอร์โทรศัพท์"
                                            name="tel"
                                            value={userData?.tel || ''}
                                            error={errorsVaridate?.tel || ''}
                                            disabled={editMode}
                                            onChange={handleChange}
                                            required
                                            margin="small"
                                        />
                                    </Grid>
                                </Grid>


                                <Typography variant="h6" component="h1" gutterBottom fontWeight={'bold'} sx={{ marginTop: '40px' }}>
                                    3. ระบุข้อมูลพนักงาน
                                </Typography>

                                <Divider />

                                <Grid container spacing={2} marginTop={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            Username
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="ใช้รหัสพนักงานในล็อคอินเข้าสู่ระบบ"
                                            name="username"
                                            value={userData?.username || ''}

                                            error={errorsVaridate.username}
                                            disabled
                                            required
                                            margin="small"
                                        />
                                    </Grid>
                                    {
                                        !viewState && (
                                            <Grid item xs={12} sm={6}>
                                                <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                                    Password
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    type='password'
                                                    label="Password"
                                                    name="password"
                                                    value={userData?.password || ''}
                                                    error={errorsVaridate.password}
                                                    onChange={handleChange}
                                                    disabled={editMode}
                                                    required
                                                    margin="small"
                                                />
                                            </Grid>
                                        )
                                    }

                                    <Grid item xs={12} sm={12}>
                                        <Typography gutterBottom sx={{ fontSize: '18px' }}>
                                            สิทธิ์การใช้งาน
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            label="สิทธิ์การใช้งาน"
                                            name="role"
                                            value={userData?.role || ''}
                                            error={errorsVaridate.role}
                                            onChange={handleChange}
                                            disabled={editMode}
                                            required
                                            margin="small"
                                        >
                                            {['Sales', 'System Admin', 'Common'].map((position) => (
                                                <MenuItem key={position} value={position}>{position}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        {
                            !editMode && (
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => navigate('/thewonderblueadmin_admin')}
                                        sx={{ mr: 1, height: '40px', bgcolor: 'black', color: 'white' }}
                                    >
                                        ยกเลิก
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        disabled={false}
                                        sx={{ ml: 1, height: '40px', width: '200px' }}
                                    >
                                        บันทึกข้อมูล
                                    </Button>
                                </Box>
                            )
                        }
                    </Paper>
                </Container>
            </Box>
        </Box>
    );
};

export default Resgiter_view;